"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _component = require("../component");

var _element = require("../utils/dom/element");

var _detect = require("../utils/dom/detect");

var _proptypes = require("../utils/proptypes");

var _document = require("../utils/dom/document");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var events = ['scroll', 'resize', 'pageshow', 'load'];
var supportSticky = (0, _element.cssSupport)('position', 'sticky');

var Sticky =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(Sticky, _PureComponent);

  function Sticky(props) {
    var _this;

    _this = _PureComponent.call(this, props) || this;
    _this.state = {};
    _this.bindElement = _this.bindElement.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.bindPlaceholder = _this.bindPlaceholder.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handlePosition = _this.handlePosition.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = Sticky.prototype;

  _proto.componentDidMount = function componentDidMount() {
    _PureComponent.prototype.componentDidMount.call(this);

    var target = this.props.target;
    this.targetElement = (0, _element.getParent)(this.element, target);
    this.handlePosition();
    this.bindScroll();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    _PureComponent.prototype.componentWillUnmount.call(this);

    this.unbindScroll();
    if (this.scrollTimer) clearTimeout(this.scrollTimer);
  };

  _proto.getStyle = function getStyle(mode, offset, left, width) {
    var _style;

    var _this$props$style$zIn = this.props.style.zIndex,
        zIndex = _this$props$style$zIn === void 0 ? 900 : _this$props$style$zIn;
    var style = (_style = {
      position: 'fixed',
      left: left,
      width: width
    }, _style[mode] = offset, _style.zIndex = zIndex, _style);

    if (this.targetElement) {
      if (supportSticky) {
        style.position = 'sticky';
      } else {
        style.position = 'absolute';

        if (mode === 'top') {
          style.transform = "translateY(" + offset + this.targetElement.scrollTop + "px)";
        } else {
          style.transform = "translateY(" + offset + this.targetElement.scrollTop + "px)";
        }

        delete style.left;
      }
    }

    return style;
  };

  _proto.setPosition = function setPosition() {
    var _this$props = this.props,
        bottom = _this$props.bottom,
        top = _this$props.top,
        target = _this$props.target;
    var _this$state = this.state,
        mode = _this$state.mode,
        scrollWidth = _this$state.scrollWidth;
    var selfRect = this.element.getBoundingClientRect();
    var scrollElement = this.targetElement || document.body;
    var scrollRect = scrollElement.getBoundingClientRect();
    var placeholderRect = this.placeholder ? this.placeholder.getBoundingClientRect() : null;
    var viewHeight = _document.docSize.height;
    var placeholderStyle = {
      width: selfRect.width,
      // if target element is not null, set height to 0
      height: target && supportSticky ? 0 : selfRect.height
    };
    var style;
    var placeholder;
    var limitTop = top;
    var limitBottom = viewHeight - bottom;

    if (this.targetElement) {
      limitTop += scrollRect.top;
      limitBottom = scrollRect.bottom - bottom;
    }

    if (top !== undefined && mode !== 'bottom') {
      if (selfRect.top < limitTop) {
        this.setState({
          scrollWidth: scrollRect.width,
          mode: 'top'
        });
        style = this.getStyle('top', top, selfRect.left, selfRect.width);
        placeholder = placeholderStyle;
      } else if (placeholderRect && selfRect.top < placeholderRect.top) {
        if (!(target && selfRect.top === limitTop)) {
          this.setState({
            mode: ''
          });
          style = {};
          placeholder = null;
        }
      } else if (this.targetElement && placeholderRect) {
        style = this.getStyle('top', top, selfRect.left, selfRect.width);
        placeholder = placeholderStyle;
      } else if (scrollWidth && placeholderRect && scrollWidth !== scrollRect.width) {
        this.setState({
          scrollWidth: scrollRect.width,
          mode: 'top'
        });
        style = this.getStyle('top', top, placeholderRect.left, placeholderRect.width);
        placeholder = placeholderStyle;
      }
    }

    if (bottom !== undefined && mode !== 'top') {
      if (selfRect.bottom > limitBottom) {
        this.setState({
          scrollWidth: scrollRect.width,
          mode: 'bottom'
        });
        style = this.getStyle('bottom', bottom, selfRect.left, selfRect.width);
        placeholder = placeholderStyle;
      } else if (placeholderRect && (this.targetElement ? scrollRect.bottom : selfRect.bottom) > placeholderRect.bottom) {
        this.setState({
          mode: ''
        });
        style = {};
        placeholder = null;
      } else if (this.targetElement && placeholderRect) {
        style = this.getStyle('bottom', bottom, selfRect.left, selfRect.width);
        placeholder = placeholderStyle;
      } else if (scrollWidth && placeholderRect && scrollWidth !== scrollRect.width) {
        this.setState({
          scrollWidth: scrollRect.width,
          mode: 'bottom'
        });
        style = this.getStyle('bottom', bottom, placeholderRect.left, placeholderRect.width);
        placeholder = placeholderStyle;
      }
    }

    if (placeholder !== undefined) {
      this.setState({
        placeholder: placeholder
      });
    }

    if (style) {
      this.setState({
        style: style
      });
    }
  };

  _proto.handlePosition = function handlePosition() {
    var _this2 = this;

    if (this.locked) {
      this.scrollCount += 1;
      return;
    }

    this.locked = true;
    this.scrollCount = 0;
    this.setPosition();
    this.scrollTimer = setTimeout(function () {
      _this2.locked = false;

      if (_this2.scrollCount > 0) {
        _this2.handlePosition();
      }
    }, 48);
  };

  _proto.bindElement = function bindElement(el) {
    this.element = el;
  };

  _proto.bindPlaceholder = function bindPlaceholder(el) {
    this.placeholder = el;
  };

  _proto.bindScroll = function bindScroll() {
    var _this3 = this;

    if (this.targetElement) {
      this.targetElement.addEventListener('scroll', this.handlePosition, _detect.eventPassive);
    } else {
      events.forEach(function (e) {
        window.addEventListener(e, _this3.handlePosition);
      });
    }
  };

  _proto.unbindScroll = function unbindScroll() {
    var _this4 = this;

    if (this.targetElement) {
      this.targetElement.removeEventListener('scroll', this.handlePosition);
    } else {
      events.forEach(function (e) {
        window.removeEventListener(e, _this4.handlePosition);
      });
    }
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        children = _this$props2.children,
        className = _this$props2.className,
        target = _this$props2.target;
    var placeholder = this.state.placeholder;
    var outerStyle = this.props.style;
    var innerStyle = this.state.style;

    if (target && supportSticky) {
      outerStyle = Object.assign({}, outerStyle, innerStyle);
      innerStyle = {};
    }

    return _react.default.createElement("div", {
      style: outerStyle,
      className: className
    }, _react.default.createElement("div", {
      ref: this.bindElement,
      style: innerStyle
    }, children), placeholder && _react.default.createElement("div", {
      ref: this.bindPlaceholder,
      style: placeholder
    }));
  };

  return Sticky;
}(_component.PureComponent);

Sticky.propTypes = _objectSpread({}, (0, _proptypes.getProps)(_propTypes.default), {
  bottom: _propTypes.default.number,
  children: _propTypes.default.any.isRequired,
  target: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  top: _propTypes.default.number
});
Sticky.defaultProps = _objectSpread({}, _proptypes.defaultProps);
Sticky.displayName = 'ShineoutSticky';
var _default = Sticky;
exports.default = _default;